export const refreshFileInput = (name: string) => {
    const input = document.querySelector(`[name="file_input_${name}"]`);
    if (input) {
        // @ts-ignore
        input.value = null;
    }
};